function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */
var $6db58dc88e78b024$var$pluralRulesCache = new Map();
var $6db58dc88e78b024$var$numberFormatCache = new Map();
var $6db58dc88e78b024$export$2f817fcdc4b89ae0 = /*#__PURE__*/function () {
  function $6db58dc88e78b024$export$2f817fcdc4b89ae0(locale, strings) {
    _classCallCheck(this, $6db58dc88e78b024$export$2f817fcdc4b89ae0);
    this.locale = locale;
    this.strings = strings;
  }
  return _createClass($6db58dc88e78b024$export$2f817fcdc4b89ae0, [{
    key: "format",
    value: /** Formats a localized string for the given key with the provided variables. */function format(key, variables) {
      var message = this.strings.getStringForLocale(key, this.locale);
      return typeof message === 'function' ? message(variables, this) : message;
    }
  }, {
    key: "plural",
    value: function plural(count, options) {
      var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'cardinal';
      var opt = options['=' + count];
      if (opt) return typeof opt === 'function' ? opt() : opt;
      var key = this.locale + ':' + type;
      var pluralRules = $6db58dc88e78b024$var$pluralRulesCache.get(key);
      if (!pluralRules) {
        pluralRules = new Intl.PluralRules(this.locale, {
          type: type
        });
        $6db58dc88e78b024$var$pluralRulesCache.set(key, pluralRules);
      }
      var selected = pluralRules.select(count);
      opt = options[selected] || options.other;
      return typeof opt === 'function' ? opt() : opt;
    }
  }, {
    key: "number",
    value: function number(value) {
      var numberFormat = $6db58dc88e78b024$var$numberFormatCache.get(this.locale);
      if (!numberFormat) {
        numberFormat = new Intl.NumberFormat(this.locale);
        $6db58dc88e78b024$var$numberFormatCache.set(this.locale, numberFormat);
      }
      return numberFormat.format(value);
    }
  }, {
    key: "select",
    value: function select(options, value) {
      var opt = options[value] || options.other;
      return typeof opt === 'function' ? opt() : opt;
    }
  }]);
}();
export { $6db58dc88e78b024$export$2f817fcdc4b89ae0 as LocalizedStringFormatter };